import React from "react";

export const SettingsIcon2 = () => {
  return (
    <svg width={17} height={17} viewBox="0 0 17 17" fill="none">
      <path
        d="M8.333 10.334a2 2 0 100-4 2 2 0 000 4z"
        stroke="#01A8CE"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M13.267 10.333a1.1 1.1 0 00.22 1.214l.04.04a1.333 1.333 0 11-1.887 1.886l-.04-.04a1.1 1.1 0 00-1.213-.22 1.1 1.1 0 00-.667 1.007v.113a1.333 1.333 0 11-2.667 0v-.06a1.1 1.1 0 00-.72-1.006 1.1 1.1 0 00-1.213.22l-.04.04a1.334 1.334 0 11-1.887-1.887l.04-.04a1.1 1.1 0 00.22-1.213 1.1 1.1 0 00-1.006-.667h-.114a1.333 1.333 0 010-2.667h.06a1.1 1.1 0 001.007-.72 1.1 1.1 0 00-.22-1.213l-.04-.04a1.333 1.333 0 111.887-1.887l.04.04a1.1 1.1 0 001.213.22h.053A1.1 1.1 0 007 2.447v-.114a1.333 1.333 0 012.667 0v.06a1.1 1.1 0 00.666 1.007 1.1 1.1 0 001.214-.22l.04-.04a1.332 1.332 0 012.277.943 1.333 1.333 0 01-.39.944l-.04.04a1.1 1.1 0 00-.22 1.213v.053A1.1 1.1 0 0014.22 7h.113a1.333 1.333 0 110 2.667h-.06a1.1 1.1 0 00-1.006.666v0z"
        stroke="#01A8CE"
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
